<template>
  <v-row no-gutters>
    <v-col>
      <sidebar-row>
        <v-row no-gutters>
          <v-col>
            <v-subheader class="text-left text-body-1 font-weight-bold font--text pa-0">
              {{ $i18n.t(translationPath) }}
            </v-subheader>
          </v-col>
          <v-col align-self="center" cols="auto">
            <base-rounded-button
              icon="mdi-plus"
              size="x-small"
              color="success"
              :tooltip="$i18n.t('button.addRule')"
              @click="$emit('addRule', { type: ruleType })"
            />
          </v-col>
        </v-row>
      </sidebar-row>
      <sidebar-row>
        <v-row no-gutters>
          <modeling-rules-list
            :rules="rules"
            @editRule="$emit('editRule', $event)"
            @deleteRule="$emit('deleteRule', $event)"
          >
          </modeling-rules-list>
        </v-row>
      </sidebar-row>
    </v-col>
  </v-row>
</template>

<script>
import SidebarRow from '@/components/SidebarRow';
import ModelingRulesList from '@/components/ModelingRulesList';

export default {
  name: 'ModelingRuleRow',
  components: { ModelingRulesList, SidebarRow },
  props: {
    ruleType: {
      type: String,
      default: '',
    },
    translationPath: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped></style>
